import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { CartContext } from "components/CartContext";
import { StoreContext } from "components/StoreContext";
import SearchResultProductInfo from "./SearchResultProductInfo";
import {
  SearchResultNormalPricing,
  SearchResultEnterprisePricing
} from "./resultPricingComponent";

const ProductSearchResult = ({
  sku,
  productName,
  shortDescription,
  partnerName,
  partnerImage,
  partnerCode,
  ceCredits,
  isPurchasable,
  courseBundleCount,
  salePrice,
  retailPrice,
  showPrice,
  id
}) => {
  const { cart, onCartAdd } = useContext(CartContext);
  const { getPartnerByCode } = useContext(StoreContext);
  const [added, setAdded] = useState(false);
  const found = cart.items.find(o => o.sku === sku) !== undefined;
  let partnerNameSEO = "";

  if (partnerName && partnerCode) {
    const partner = getPartnerByCode(partnerCode);
    partnerNameSEO = partner.nameSEO;
  }

  const noPrice =
    isPurchasable === false || (isPurchasable && showPrice === false);

  return noPrice ? (
    <div className="products__result" id="searchResultEnterprisePricing">
      <SearchResultProductInfo
        ceCredits={ceCredits}
        productName={productName}
        sku={sku}
        courseBundleCount={courseBundleCount}
        shortDescription={shortDescription}
        partnerName={partnerName}
        partnerNameSEO={partnerNameSEO}
        partnerImage={partnerImage}
      />
      <SearchResultEnterprisePricing
        onCartAdd={onCartAdd}
        setAdded={setAdded}
        salePrice={salePrice}
        retailPrice={retailPrice}
        found={found}
        added={added}
        sku={sku}
        id={id}
        productName={productName}
        showPrice={showPrice}
      />
    </div>
  ) : (
    <div className="products__result" id="searchResultNormalPricing">
      <SearchResultProductInfo
        ceCredits={ceCredits}
        productName={productName}
        sku={sku}
        courseBundleCount={courseBundleCount}
        shortDescription={shortDescription}
        partnerName={partnerName}
        partnerNameSEO={partnerNameSEO}
        partnerImage={partnerImage}
      />
      <SearchResultNormalPricing
        onCartAdd={onCartAdd}
        setAdded={setAdded}
        salePrice={salePrice}
        retailPrice={retailPrice}
        found={found}
        added={added}
        sku={sku}
        id={id}
      />
    </div>
  );
};
export default ProductSearchResult;

ProductSearchResult.propTypes = {
  productName: PropTypes.string.isRequired,
  showPrice: PropTypes.bool,
  id: PropTypes.number,
  sku: PropTypes.string.isRequired,
  shortDescription: PropTypes.string,
  partnerName: PropTypes.string,
  partnerImage: PropTypes.string,
  partnerCode: PropTypes.string,
  ceCredits: PropTypes.number.isRequired,
  isPurchasable: PropTypes.bool,
  retailPrice: PropTypes.number,
  salePrice: PropTypes.number,
  courseBundleCount: PropTypes.number.isRequired
};
ProductSearchResult.defaultProps = {
  shortDescription: null,
  showPrice: undefined,
  id: null,
  partnerName: null,
  partnerImage: null,
  partnerCode: null,
  retailPrice: null,
  salePrice: null,
  isPurchasable: undefined
};
